import styled from "styled-components";
import { margins } from "../../styles/styles";

export const PaymentsWrappper = styled.div`
    margin: auto;

    .title {
        margin-bottom: ${margins.L};
    }
`;